var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEways(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 28.8408,
    rx: 29.5,
    ry: 28.8408,
    fill: "#74BF59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8402 17.5709C28.5616 16.6115 30.0442 16.6618 30.6959 17.6677L32.7974 20.9116C31.4095 20.6921 30.0883 21.556 29.8177 22.88C29.5407 24.2359 30.4705 25.5608 31.8944 25.8393L37.5828 26.952C39.0895 27.2467 40.5515 26.3323 40.8619 24.9011L42.0333 19.4978C42.3265 18.1452 41.4125 16.8104 39.9918 16.5165C38.74 16.2575 37.5124 16.8929 37.0377 17.9728L35.081 14.9524C32.4741 10.9286 26.5438 10.7276 23.6581 14.5651L22.1222 16.6075C21.2732 17.7365 21.5212 19.3247 22.676 20.1547C23.8309 20.9848 25.4553 20.7424 26.3043 19.6133L27.8402 17.5709Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5175 28.2087C13.2234 28.3475 12.0033 27.5502 11.7019 26.3104C11.3747 24.9646 12.2542 23.6072 13.6663 23.2786L19.3075 21.9656C20.7995 21.6184 22.2925 22.4783 22.658 23.8956L24.0403 29.254C24.3862 30.5954 23.5256 31.9637 22.118 32.3102C20.7957 32.6358 19.4611 31.9438 19.0174 30.7468L16.866 34.0677C16.1363 35.1939 16.964 36.6643 18.3276 36.6643H22.0986C23.532 36.6643 24.6939 37.8004 24.6939 39.2017C24.6939 40.6029 23.532 41.739 22.0986 41.739H18.3276C12.8731 41.739 9.56231 35.8573 12.4809 31.3524L14.5175 28.2087Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8192 41.1428C27.7972 41.122 27.7758 41.1008 27.7547 41.0795C27.2325 40.6154 26.9048 39.946 26.9048 39.2017C26.9048 38.4575 27.2325 37.7881 27.7547 37.324C27.7758 37.3026 27.7972 37.2815 27.8192 37.2605L31.9208 33.3646C32.9489 32.388 34.5919 32.4112 35.5908 33.4162C36.481 34.3118 36.559 35.685 35.838 36.6644H40.3185C41.7108 36.6644 42.5329 35.1383 41.7451 34.0158L40.0483 31.5981C39.2373 30.4426 39.5381 28.8632 40.72 28.0704C41.9019 27.2776 43.5174 27.5715 44.3283 28.727L46.0251 31.1448C49.1763 35.6346 45.8881 41.739 40.3185 41.739H35.838C36.559 42.7184 36.481 44.0916 35.5908 44.9873C34.5919 45.9923 32.9489 46.0154 31.9208 45.0389L27.8192 41.1428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEways);
export default __webpack_public_path__ + "static/media/eways.a306385f1268fb9263abf9f253dc6395.svg";
export { ForwardRef as ReactComponent };